import { useDispatch } from 'react-redux';
export var useAppDispatch = function () { return useDispatch(); };
